import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import createPersistedState from 'vuex-persistedstate'
import router from './router';

Vue.use(Vuex)

export default new Vuex.Store({    
  state: {    
    appversion: '1.3.18c',
    usuario:{
      id: '',
      nombre: '',
      vendedor: '',
      userGUID: '',
      salesGroup: '',
      discGroup: '',
      custNo: '',
      custName: '',
      type: '',
      editPrices: false,
      invoiceDisc: [],
      email: '',
      lastEmail: '',
      lastActiveTime: ''
    },
    appconfig:{
      appname1: '',
      appname2: '',
      autoventa: false,
      showAppSufix: false,
      defaultOrderType: '',
      showLineCategories: false,
      showItemPhoto: false,
      filterInvoiceDocumentDate: false,
      allowUOMS: false,
      showVAT: false,
      promociones: false,
      version: '',
      revision: '',
      servicesLanguage: '',
      enableCustGroups: false,
      topItems: 20,
      showNoStockCust: true,
      showNoStockSeller: true,
      showLogoImg: false,
      tracking: false,
      userCustomerRelationType: 0, //0 = user; 1 = shipping agent
    },
    usuarioLogeado : false,
    items: [], //Resultado de las busquedas
    orderItems: [], //Lineas de pedido
    colorselected: 'primary',
    colornoselected: 'black',
    orderbygroup : false,
    topventas : false,
    onlyAvailable : false,
    onlyPromos : false,
    creatingOrder : false,    
    menuitems: [
      {
        active: true,
        action: 'list',
        title: 'Categorías',
        items: [],
        selectedItems: []
      }
    ],    
    filter : '', //filtro productos
    custFilter: '',
    loaderData:{
      value: 0,
      query: false,
      show: true,
      interval: 0,
      active: false
    },
    activeAxiosComms:{
      categories: false,
      items: false,
      order: false,
      orderLine: false,
      posting: false,
      customer: false,
      invoices: false,
      anularFactura: false,
      cobrarFactura: false,
      login: false,
      rutas: false
    },
    calEventDialog: false,
    calEventDialogData: {
      titulo: '',
      contenido: '',
      event: null  
    },
    globalDialog: false,
    globalDialogData: {
      titulo: '',
      contenido: '',
      returnMenu: false     
    },
    globalConfirmDialog: false,
    globalConfirmDialogData: {
      titulo: '',
      contenido: '',
      returnMenu: false     
    },
    dialogAddresses: false,
    dialogCustInfo: false,
    navMenu:[{
        id: 1,
        title: 'Catálogo',
        color: '',
        icon : 'library_books',
        userType: 'all'
    },{
        id: 2,
        title: 'Pedido',
        color: '',
        icon : 'shopping_cart',
        userType: 'all'
    },{
        id: 3,
        title: 'Historial',
        color: '',
        icon : 'playlist_add_check',
        userType: 'all'
    }],
    fechas:[
      {
      text: 'Fecha creación desde',
      modal: false,
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: ''//this.formatDate(new Date().toISOString().substr(0, 10))
      },
      {
      text: 'Fecha creación hasta',
      modal: false,
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: ''//this.formatDate(new Date().toISOString().substr(0, 10))
      },
      {
      text: 'Fecha registro desde',
      modal: false,
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: ''//this.formatDate(new Date().toISOString().substr(0, 10))
      },
      {
      text: 'Fecha registro hasta',
      modal: false,
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: ''//this.formatDate(new Date().toISOString().substr(0, 10))
      }
    ],
    dialogComercial: false,
    customers: [],
    selectedCustIndex: -1,        
    tipoDocumento: '',
    facturas: [],
    facturaActual: [],
    selectedInvIndex: -1,
    dialogInformeComerciales: false,
    dialogRetrievePass: false,
    tipoInforme: 'Contado',
    dialogTipoCobro: false,
    tipoCobro: 'Efectivo',
    documentNos: [],
    numCheque: 0,
    printhref: '',
    //Dialog Edicion
    dialogEditItem: false,
    dialogData: {
        code: '',
        title: '',
        picture: '',
        pictureLazy: ''
    },                
    editedIndex: -1,
    editedItems: [
      //Se inicializa solo con este campo para que no de problemas el componente de dialogEditItem, que lee este campo en un v-if
      //Si no se pone este valor, da un error de que se intenta acceder a un campo de un valor 'undefined'
      {trackingEnabled: false}
    ],
    sameNoItems: [],
    sameNoItemsBackup: [],
    //Dialog edicion </>
    //True: abierto, False: cerrado
    menuLateralDrawer: true,
    menuVerticalDrawer: true,
    promosDestacadas: [],
    promosDestacadasVisible: true,
    axiosSource: undefined, //Items
    axiosSourceCustomers: undefined, //Customers
    loginError: false,
    loginErrorMsg: '',
    docNameVisible: true,
    promocionesGrupos: [],
    rutasEventos: [],
    idEvento: '',
    notaPedido: '',
    notaRepartidor: '',
    newCust: false, //Variable global para controlar cuando se muestra el formulario de nuevo cliente
    newCustData: {
      name: '',
      searchName: '',
      cif: ''
    },
    newCustNo: '',
    searchLarge: true,
    buscadorAbierto : false,
    windowSize: {
      x: 0,
      y: 0,
    },
    isMenu: true,
    isCheckingPrice: false,
    Available: [],
    availabilityListVisible: false,
    onlyPending: false,
    dialogLastOrder: false,
    dialogLastOrderData: {},
  },
  mutations: {
    increment (state) {
      state.count++
    },
    change(state, flavor) {
      state.flavor = flavor
    },
    loginUser(state, data){           
      //TODO:
      //Pasar alerts a vuetify 
      //var ret = data.return_value; //Slim
      var ret = data.response; //API
			if ((ret == '401')||(ret == '400')){
				if (ret == '401') {
          //$("#popup").html('<p>Contraseña incorrecta</p>');
          //alert('Contraseña incorrecta');
          state.loginError = true;
          state.loginErrorMsg = 'Error en el inicio de sesión';
        }
				else{
					//$("#popup").html('<p>No existe el usuario</p>');
				//$("#popup").popup("open"); 
        //setTimeout(function(){  $("#popup").popup("close"); }, 5000);
          //alert('No existe el usuario');
          state.loginError = true;
          state.loginErrorMsg = 'Error en el inicio de sesión';
        }
			} else {				     
        state.usuario.nombre = data.name;
        state.usuario.vendedor = data.salesperson;
        //state.usuario.userGUID = '{' + data[0].guid + '}';
        state.usuario.userGUID = ret;
        state.usuario.salesGroup = data.custPriceGroup;
        state.usuario.discGroup = data.custDiscGroup;
        state.usuario.custNo = data.custNo;
        state.usuario.type = data.type;
        state.usuario.editPrices = data.editPrices;
        state.usuario.invoiceDisc = data.invoiceDisc;
        state.usuario.custName = data.custName;
        state.usuario.email = data.email;
        state.usuario.lastEmail = data.email; 
        state.usuario.lastActiveTime = new Date().toISOString();     
        state.usuarioLogeado = true;   
        if (data.currentCart != ''){
          var lines = JSON.parse(data.currentCart);
          state.orderItems = lines;
        }
        if ((state.usuario.type == 'COMERCIAL') &&(state.orderItems = [])) {          
          state.dialogComercial = true;
        }
        //console.log(data);            
			}
    },    
    saveUserId(state,value){
      state.usuario.id = value;      
    },
    logout(state){
      state.usuarioLogeado = false;
      state.usuario = {
        id: '',
        nombre: '',
        vendedor: '',
        userGUID: '',
        salesGroup: '',
        custNo: ''      
      };
      router.push('/');
    },
    setOrderItems(state,value){
      state.orderItems = value;
    },
    resetOrderItems(state){    
      state.orderbygroup = false;
      state.topventas = false;
      state.onlyPromos = false;
      state.onlyAvailable = true;
      state.menuitems[0].selectedItems = [];
      state.tipoDocumento = state.appconfig.defaultOrderType;
      state.idEvento = '';
      state.orderItems = [];      
      state.notaPedido = '';
      state.notaRepartidor = '';
      state.filter = '';
    },
    setOrderByGroup(state, value){
      state.orderbygroup = value;
    },
    setTopVentas(state,value){
      state.topventas = value;
    },
    setMenuItems(state,value){
      state.menuitems = value;
    },
    setItems(state, value){
      state.items = value;
    },
    setItemsFilter(state, value){
      state.filter = value;
    },
    flipLoading(state){
      state.creatingOrder = !state.creatingOrder;
    },
    startLoading(state){
      state.creatingOrder = true;
    },
    endLoading(state){
      state.creatingOrder = false;
    },
    showGlobalLoader(state){
      //Timeout 20s
      state.loaderData.active = true;
      setTimeout(() => {
          state.loaderData.active = false;
      },30000);
    },
    hideGlobalLoader(state){
      if ((!state.activeAxiosComms.categories) &&
        (!state.activeAxiosComms.items) &&
        (!state.activeAxiosComms.order) &&
        (!state.activeAxiosComms.orderLine) &&
        (!state.activeAxiosComms.posting) &&
        (!state.activeAxiosComms.customer) &&
        (!state.activeAxiosComms.invoices) &&
        (!state.activeAxiosComms.anularFactura) &&
        (!state.activeAxiosComms.cobrarFactura) &&
        (!state.activeAxiosComms.login) &&
        (!state.activeAxiosComms.rutas)         
        ){
          state.loaderData.active = false;
        }      
    },
    setGlobalDialog(state,value){
      state.globalDialog = value;
    },
    setCalEventdialog(state,value){
      state.calEventDialog = value;
    },
    setNavMenu(state,value){
      state.navMenu = value;
    },
    setCustFilter(state,value){
      state.custFilter = value;
    },
    setCustomers(state,value){
      state.customers = value;
    },
    setSelectedCust(state, value){
      state.selectedCustIndex = value;
    },
    setTipoDocumento(state,value){
      state.tipoDocumento = value;
    },
    setDialogComercial(state,value){
      state.dialogComercial = value;
    },
    setSelectedInvoice(state,value){
      state.selectedInvIndex = value;
    },
    setDates(state,value){
      state.fechas = value;
    },
    setInvoices(state,value){
      state.facturas = value;
    },
    setRutas(state,value){
      state.rutasEventos = value;
    },
    setNotaPedido(state,value){
      state.notaPedido = value;
    },
    setNotaRepartidor(state,value){
      state.notaRepartidor = value;
    },
    setNewCustData(state,value){
      state.newCustData = value;
    },
    setSearchLarge(state,value){
      state.searchLarge = value;
    },
    setBuscadorAbierto(state,value){
      state.buscadorAbierto = value;
    },
    setIsMenu(state,value){
      state.isMenu = value;
    },
    setIsCheckingPrice(state,value){
      state.isCheckingPrice = value;
    },
    setCustomerLoading(state,value){
      state.activeAxiosComms.customer = value;
    },
    setAvailable(state,value){
      state.Available = value;
    },
    setOnlyPending(state,value){
      state.onlyPending = value;
    },  
  },
  actions: {
    getItems(store){
      ///items/false/' + getCookie('usuario') + '/' + getCookie('userGUID') + '/-1/-1/' + filter,      
    }    
  },
  getters: {
    flavor: state => state.flavor,
    count: state => state.count,  
    usuario: state => state.usuario,
    nombreUsuario: state => state.nombreUsuario,
  },  
  //Variables que se guardan de manera permantente incluso si se actualiza la página
  plugins: [createPersistedState({
    key: 'AppData',
    paths: ['usuario','usuarioLogeado','orderItems','items',
          'customers','selectedCustIndex','tipoDocumento','filter','appconfig','custFilter','docNameVisible','searchLarge','buscadorAbierto']
  })] 
})
